import { render, staticRenderFns } from "./tiny-editor.vue?vue&type=template&id=7fed18a5"
import script from "./tiny-editor.vue?vue&type=script&lang=js"
export * from "./tiny-editor.vue?vue&type=script&lang=js"
import style0 from "./tiny-editor.vue?vue&type=style&index=0&id=7fed18a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports